//this closure ensures we won't be interfering with other libraries that have defined $
(function($) {

	var offset = 52;
	
    var showCustomStatus = function(message, type, containerID) {
        var statusContainer = $('#' + containerID);
        var statusBlock = statusContainer.find('status-block');
        var statusText = statusContainer.find('.status-text');
        statusContainer.stop(true, true);
        statusText.html(message);
        statusText.attr('title', message);
        statusText.attr('aria-label', message);
        
        if (type === 'error') {
            statusBlock.removeClass('success');
            statusBlock.removeClass('warn');
            statusBlock.addClass('error');
        } else if (type === 'warn') {
            statusBlock.removeClass('success');
            statusBlock.removeClass('error');
            statusBlock.addClass('warn');
        } else {
            statusBlock.removeClass('error');
            statusBlock.removeClass('warn');
            statusBlock.addClass('success');
        }
        
        statusContainer.slideDown();
    };
    
    var statusSection = function(containerID) {
        var statusSectionID = containerID;
        
        var showSectionStatus = function(message, type) {
            var statusContainer = $(statusSectionID);
            var statusBlock = statusContainer.find('.status-block');
            var statusText = statusContainer.find('.status-text');
            statusContainer.stop(true, true);
            statusText.html(message);
            statusText.attr('title', message);
            statusText.attr('aria-label', message);
            
            if (type === 'error') {
                statusBlock.removeClass('success');
                statusBlock.removeClass('warn');
                statusBlock.addClass('error');
            } else if (type === 'warn') {
                statusBlock.removeClass('success');
                statusBlock.removeClass('error');
                statusBlock.addClass('warn');
            } else {
                statusBlock.removeClass('error');
                statusBlock.removeClass('warn');
                statusBlock.addClass('success');
            }
            
            if (!statusContainer.is(':visible')) {
                statusContainer.slideDown();
            }
        };
        
        var clearSectionStatus =  function() {
            $(statusSectionID).slideUp(function() {
                var statusText = $(statusSectionID + ' .status-text');
                statusText.html('');
                statusText.attr('title', '');
                statusText.attr('aria-label', '');
            });
        }
        
        $(statusSectionID + ' .status-closer').on('click', function() {
            clearSectionStatus();
        });

        return {
            showErrorStatus : function(message) {
                showSectionStatus(message, 'error');
            },
            showWarningStatus : function(message) {
                showSectionStatus(message, 'warn');
            },
            showSuccessStatus : function(message) {
                showSectionStatus(message, 'success');
            },
            appendStatus : function(message, isSuccess) {
                showSectionStatus($(statusSectionID + ' .status-text').text() + " " + message, ((isSuccess)? 'success' : 'error'));
            },
            clearStatus : function() {
                clearSectionStatus();
            }
        }
    };
    
    var showStatusRedir = function(message, type) {
        var statusBlock = $('#statusBlock');
        var statusContainer = statusBlock.parent();
        var statusText = statusBlock.find('.status-text');
        statusContainer.stop(true, true);
        statusText.html(message);
        statusBlock.removeClass('error');
        statusBlock.removeClass('warn');
        statusBlock.addClass('success');
        
        if (!statusContainer.is(':visible')) {        
            statusContainer.slideDown();
        }
    };
    
    var showStatus = function(message, type, title) {
        var statusBlock = $('#statusBlock');
        var statusContainer = statusBlock.parent();
        var statusText = statusBlock.find('.status-text');
        var recordingsLinkTemplate = '<a href="jsp/recordings/recordings.jsp?archivename={{archiveName}}">{{archiveName}}</a>';
        statusContainer.stop(true, true);
        statusText.html(message);
        statusText.attr('aria-label', message);
        
      //listen for clicks if not on the message bar close message
        $('body').on('click.hideMenu', function(e) {
            if (!($(e.target).parents().find('.status-block.error'))) {
         		$.clearStatus();
        	}
        });
        
        if(title === undefined || title === ""){
        	statusText.attr('title', message);
        } else {
        	statusText.attr('title', title);
        }        
        
        if (type === 'error') {
            statusBlock.removeClass('success');
            statusBlock.removeClass('warn');
            statusBlock.addClass('error');
        } else if (type === 'warn') {
            statusBlock.removeClass('success');
            statusBlock.removeClass('error');
            statusBlock.addClass('warn');
        } else {
            statusBlock.removeClass('error');
            statusBlock.removeClass('warn');
            statusBlock.addClass('success');
        }
        
        if (!statusContainer.is(':visible')) {        
            statusContainer.slideDown();
        }
        //Calling this so that if the user has scrolled down
        //we can display the error message properly
        floatCheck();
    };
    
    $.extend({
    	setStatusOffset : function(pos){
    		offset = pos;
    	},
        createStatusSection : function(containerID) {
            return statusSection(containerID);
        },
        showErrorStatus : function(message) {
            showStatus(message, 'error');
        },
        showWarningStatus : function(message) {
            showStatus(message, 'warn');
        },
        showSuccessStatus : function(message) {
            showStatus(message, 'success');
        },
        showSuccessStatusReDir : function(message) {
        	showStatusRedir(message, 'success');
        },
        showNoLinkStatus : function(message, title){
        	showStatus(message, 'warn', title);
        },
        /**
         * Append the message
         * @param message
         * @param isSuccess
         */
        appendStatus : function(message, isSuccess) {
            showStatus($('#statusBlock .status-text').text() + " " + message, ((isSuccess)? 'success' : 'error'));
        },
        
        clearStatus : function() {
            var statusSectionContainer = $('#statusBlock').parent();
            
            statusSectionContainer.slideUp(function() {
                var statusText = $('#statusBlock .status-text');
                statusText.html('');
                statusText.attr('title', '');
                statusText.attr('aria-label', '');
                
                //remove the listener for the message clear click
                $('body').unbind('click.hideMenu');
                
                // CWE-92831: When statusSection is inside a form, if statusBlock has
                // a class of "error", then form validation will do a seek-and-destroy
                // on it...
                $('#statusBlock').removeClass('error');
            });
        }
    });
    
    $(document).ready(function() {
        $('#statusBlock .status-closer').on('click', function() {
            $.clearStatus();
        });
    });
    
    //The code below sticks the status message to the top of the screen 
    //if the user has scrolled down past it
    
    var $window = $(window);
    var $statusSection = $('#statusSection');
    var $scrollTop;
	
	$window.on('scroll', function() {
		floatCheck();
	});
	
	var floatCheck = function() {
        	$scrollTop = $window.scrollTop();
        	if($scrollTop > offset){
        		$statusSection.offset({ top: $scrollTop});
        	}else{
        		$statusSection.offset({ top: offset });
        	}
    };
	
})(jQuery);